export const BACKGROUND_COLOR = 'var(--brand-color-canvas-subtle)'
export const DARK_BACKGROUND_COLOR = '#0F1511'
export const GRID_LINE_COLOR = 'var(--brand-color-border-subtle)'
export const DARK_GRID_LINE_COLOR = '#262C28'
export const COLORS = ['#5FED83', '#C898FD', '#DA7210', '#8DD6FF', '#0FBF3E', '#5FB9FF', '#08872B'] as const

// Cell order controls the chase direction: clockwise on the left, counterclockwise on the right.
export const CORNER_DOTS = {
  left: [
    {x: 0, y: 0, color: 'var(--base-color-scale-green-4)'},
    {x: 1, y: 0, color: 'var(--base-color-scale-green-6)'},
    {x: 1, y: 1, color: 'var(--base-color-scale-purple-4)'},
    {x: 0, y: 1, color: 'var(--base-color-scale-blue-4)'},
  ],
  right: [
    {x: 0, y: 0, color: 'var(--base-color-scale-orange-4)'},
    {x: 0, y: 1, color: 'var(--base-color-scale-green-6)'},
    {x: 1, y: 1, color: 'var(--base-color-scale-blue-5)'},
    {x: 1, y: 0, color: 'var(--base-color-scale-yellow-4)'},
  ],
} as const
